module.exports = __webpack_public_path__ + "static/media/Big Fire.51567bc6.png";